const SQL_INJECTION_PATTERN = /[\0;'"\\]|(\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|ALTER|EXEC|TRUNCATE|--)\b)/i;
const PHONE_PATTERN = /^\+[0-9]{7,15}$/;
const OTP_PATTERN = /^\d{4}$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{4,20}$/;
const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/;
const PERSON_NAME_PATTERN = /^[\p{L}\p{M}\s'.-]+$/u;
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const TRANSACTION_STATUSES = new Set([
  'Creando',
  'En pago',
  'en pago',
  'Método seleccionado',
  'Procesando',
  'Completado',
  'Cancelada',
]);

const USER_ROLES = new Set(['usuario', 'administrador', 'cliente']);

export const rejectIfSqlLike = (value, fieldName = 'valor') => {
  if (value == null || value === '') return value;
  const str = String(value).trim();
  if (SQL_INJECTION_PATTERN.test(str)) {
    throw new Error(`${fieldName} contiene caracteres no permitidos.`);
  }
  return str;
};

export const parsePositiveInt = (value, fieldName = 'ID') => {
  const id = Number(value);
  if (!Number.isInteger(id) || id <= 0) {
    throw new Error(`${fieldName} inválido.`);
  }
  return id;
};

export const parseUuid = (value, fieldName = 'ID') => {
  const str = String(value ?? '').trim();
  rejectIfSqlLike(str, fieldName);
  if (!UUID_PATTERN.test(str)) {
    throw new Error(`${fieldName} inválido.`);
  }
  return str;
};

export const normalizePhone = (phone) => {
  const raw = String(phone || '').trim();
  const normalized = raw.startsWith('+') ? raw : `+${raw}`;
  rejectIfSqlLike(normalized, 'Teléfono');
  if (!PHONE_PATTERN.test(normalized)) {
    throw new Error('Formato de teléfono inválido.');
  }
  return normalized;
};

export const validateOtpCode = (code) => {
  const value = String(code || '').trim();
  if (!OTP_PATTERN.test(value)) {
    throw new Error('El código debe tener 4 dígitos.');
  }
  return value;
};

export const validatePassword = (password) => {
  const value = String(password || '');
  rejectIfSqlLike(value, 'Contraseña');
  if (value.length < 6 || value.length > 128) {
    throw new Error('La contraseña debe tener entre 6 y 128 caracteres.');
  }
  return value;
};

export const validatePersonName = (name, fieldName = 'Nombre') => {
  const value = rejectIfSqlLike(String(name || '').trim(), fieldName);
  if (!value || value.length > 80) {
    throw new Error(`${fieldName} inválido.`);
  }
  if (!PERSON_NAME_PATTERN.test(value)) {
    throw new Error(`${fieldName} contiene caracteres no permitidos.`);
  }
  return value;
};

export const validateEmail = (email) => {
  const value = rejectIfSqlLike(String(email || '').trim(), 'Correo');
  if (!value) return null;
  if (value.length > 254 || !EMAIL_PATTERN.test(value)) {
    throw new Error('Correo electrónico inválido.');
  }
  return value.toLowerCase();
};

export const validateReferralCode = (code) => {
  const value = rejectIfSqlLike(String(code || '').trim().toUpperCase(), 'Código de referido');
  if (!value) return null;
  if (!REFERRAL_CODE_PATTERN.test(value)) {
    throw new Error('Código de referido inválido.');
  }
  return value;
};

export const validateCountryCode = (code, fieldName = 'País') => {
  const value = rejectIfSqlLike(String(code || '').trim().toUpperCase(), fieldName);
  if (!value) return null;
  if (!COUNTRY_CODE_PATTERN.test(value)) {
    throw new Error(`${fieldName} inválido.`);
  }
  return value;
};

export const validateTransactionStatus = (status) => {
  const value = rejectIfSqlLike(String(status || '').trim(), 'Estado');
  if (!TRANSACTION_STATUSES.has(value)) {
    throw new Error('Estado de transacción inválido.');
  }
  return value;
};

export const validateUserRole = (role) => {
  const value = rejectIfSqlLike(String(role || '').trim(), 'Rol');
  if (!USER_ROLES.has(value)) {
    throw new Error('Rol inválido.');
  }
  return value;
};

export const sanitizeText = (value, { fieldName = 'Texto', maxLength = 500 } = {}) => {
  const text = rejectIfSqlLike(String(value ?? '').trim(), fieldName);
  if (text.length > maxLength) {
    throw new Error(`${fieldName} demasiado largo.`);
  }
  return text;
};

export const validateLoginIdentifier = (identifier) => {
  const value = rejectIfSqlLike(String(identifier || '').trim(), 'Identificador');
  if (!value) throw new Error('Identificador requerido.');
  if (value.includes('@')) return validateEmail(value);
  return normalizePhone(value);
};
